import { TargetPlatform } from "../../gql-generated/types";

export const onlyCameraKitSelected = (targetPlatforms: TargetPlatform[]): boolean => {
    return targetPlatforms.length === 1 && targetPlatforms[0] === TargetPlatform.CameraKit;
};
